import CapitaStarDelinkPage from "containers/CapitaStarDelinkPage/CapitaStarDelinkPage";

const KrisFlyerDelinkPage = () => {
	return <CapitaStarDelinkPage krisflyerVariant />;
};

export default KrisFlyerDelinkPage;
